import { TransactionStatus } from "Infrastructure/Api/Api";

export const UNSUCCESSFUL_STATUSES = [
  TransactionStatus.Cancelled,
  TransactionStatus.InvestigationNeeded,
  TransactionStatus.Fail,
];
